// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import qs from 'query-string';
import { withRouter } from '../../../../router-compat';
import configs from '../configs';
import { IntegrationLayout, OAuthSetup, ExternalLinkA } from '../_shared';

class Mailchimp extends Component {
  componentDidMount() {
    this.props.store.integrations.Mailchimp.getConfigs();
    const { code } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (code) this.props.store.integrations.Mailchimp.getTokens(code);
  }

  render() {
    return (
      <IntegrationLayout config={configs.Mailchimp}>
        <OAuthSetup
          partnerKey="Mailchimp"
          steps={[
            <>Create a Mailchimp account <ExternalLinkA href="https://login.mailchimp.com/signup/">here</ExternalLinkA> if you don&apos;t have one already.</>,
            'Grant Movology the necessary permissions:',
            'Add our code snippet and start adding forms in the Forms tab.',
            <>Manage future captures in your <ExternalLinkA href="https://admin.mailchimp.com/audience/">Mailchimp Audience</ExternalLinkA>.</>,
          ]}
        />
      </IntegrationLayout>
    );
  }
}

export default withRouter(inject('store')(observer(Mailchimp)));
